import classNames from "classnames"
import PropTypes from "prop-types"
import React from "react"

import { formatCurrencyFromMinorUnits } from "src/utils/UnitConversion"

const Total = ({
  label,
  amount,
  loading,
  currency = "USD",
  variant = "default",
}) => {
  const classes = classNames("flex", "items-center", "justify-between", {
    "text-red-600 font-semibold": variant === "red",
    "text-gray-900": variant === "default",
  })

  return (
    <div className={classes}>
      <span className="font-semibold">{label}</span>
      <div className="h-6">
        {loading ? (
          <i className="icon icon-spinner icon-spin h-full" />
        ) : (
          <span className="text-lg font-semibold">
            {formatCurrencyFromMinorUnits({ amount, currency })}
          </span>
        )}
      </div>
    </div>
  )
}

Total.propTypes = {
  label: PropTypes.string.isRequired,
  amount: PropTypes.number.isRequired,
  loading: PropTypes.bool,
  currency: PropTypes.string,
  variant: PropTypes.string,
}

export default Total
